import Vue from 'vue';
import Router from 'vue-router';

// Home / Kitchen Sink container
import ComponentBrowser from '../views/kitchen-sink/KitchenSink';

// Containers
import DocumentBrowser from '../containers/DocumentBrowser';



Vue.use(Router);

export default new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: ComponentBrowser
    },
    {
      path: '/document-browser/:id',
      name: 'Document Browser',
      component: DocumentBrowser
    }
  ]
})
